"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const chart_form_1 = __importDefault(require("./chart.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
const AriFormUtils = __importStar(require("../../../utils/utils"));
const lodash_1 = __importDefault(require("lodash"));
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class ChartComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.generateRandomColor = () => {
            // Tạo màu HEX ngẫu nhiên
            return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
        };
        this.getRandomColors = (colors, usedColors = []) => {
            const availableColors = colors.filter(color => !usedColors.includes(color));
            // Nếu hết màu, tạo màu mới và thêm vào danh sách
            while (availableColors.length === 0) {
                let newColor;
                do {
                    newColor = this.generateRandomColor();
                } while (new Set([...colors, ...usedColors]).has(newColor)); // Đảm bảo không trùng
                colors.push(newColor); // Lưu lại màu mới vào danh sách
                availableColors.push(newColor);
            }
            // Lấy màu ngẫu nhiên
            return availableColors[Math.floor(Math.random() * availableColors.length)];
        };
        this.chartBG = [
            '#FFB6C1',
            '#FF8C42',
            '#FFD700',
            '#A3E048',
            '#42C2FF',
            '#FF69B4',
            '#FFA07A',
            '#FFE4B5',
            '#9FE2BF',
            '#87CEFA',
            '#E6E6FA',
            '#DA70D6',
            '#F08080',
            '#FFDAB9',
            '#B0E57C',
            '#40E0D0',
            '#F4A261',
            '#98FB98',
            '#FF6347',
            '#7EC8E3'
        ];
        this.bgUse = [];
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'chartForm',
            displayInfo: false,
            align: 'justify-content-start',
            action: 'event'
        }, ...extend);
    }
    get defaultSchema() {
        return ChartComponent.schema();
    }
    get emptyValue() {
        return this.getValue();
    }
    render() {
        var view = `<div ref="element" class="chart-container">
                      <canvas ref = "${this.component.key}-chart-canvas" id="${this.component.key}-chart"></canvas>
                </div>`;
        return super.render(view);
    }
    setValue(value, flags = {}) {
        const changed = super.setValue(value, flags);
        if (changed) {
            this.textContent = value || '';
            this.redraw();
        }
        return changed;
    }
    getValue() {
        return this.value;
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        var refs = {};
        refs[`${this.component.key}-chart-canvas`] = 'single';
        this.loadRefs(element, refs);
        const options = this.evaluate(this.component.chartOptions, {
            options: {}
        }, 'options');
        switch (this.component.dataType) {
            case 'custom':
                this.bindData(this.component.formulaDataSource, this.component.defaultRule);
                break;
            case 'aripost': {
                var args = this.evalContext(args);
                args.form = this.root;
                this.emit('requestAri', {
                    com: this.component,
                    url: this.interpolate(this.component.aricallchartdata),
                    aribody: this.component.aribody,
                    resultType: null,
                    script: (result) => {
                        const form = this.getRoot();
                        // Get the form's flattened schema components
                        const flattened = AriFormUtils.flattenComponents(form.component.components, true);
                        // Create object containing the corresponding HTML element components
                        const components = {};
                        lodash_1.default.each(flattened, (component, key) => {
                            const element = form.getComponent(key);
                            if (element) {
                                components[key] = element;
                            }
                        });
                        let dataChart = {};
                        if (this.component.customDataChart) {
                            dataChart = this.evaluate(this.component.customDataChart, {
                                form,
                                flattened,
                                components,
                                result
                            }, 'dataChart');
                        }
                        else {
                            dataChart = result;
                        }
                        if (dataChart) {
                            const bgUse = [];
                            dataChart.datasets.forEach((dataset) => {
                                const bg = this.getRandomColors(this.chartBG, bgUse);
                                bgUse.push(bg);
                                dataset.backgroundColor = bg || '';
                                dataset.borderColor = bg || '';
                            });
                        }
                        // eslint-disable-next-line no-undef
                        new Chart(document.getElementById(`${this.component.key}-chart`), {
                            type: this.component.showType,
                            data: {
                                labels: (dataChart === null || dataChart === void 0 ? void 0 : dataChart.labels) || [],
                                datasets: (dataChart === null || dataChart === void 0 ? void 0 : dataChart.datasets) || []
                            },
                            options: options
                        });
                    },
                    args: args
                });
                break;
            }
        }
        return super.attach(element);
    }
    updateValue(value, flags) {
        const changed = super.updateValue(value, flags);
        this.previousValue = this.dataValue;
        return changed;
    }
}
ChartComponent.editForm = chart_form_1.default;
ChartComponent.builderInfo = {
    title: 'Chart',
    group: 'advanced',
    icon: 'line-chart',
    weight: 3,
    documentation: 'http://help.ari.form/userguide/',
    schema: ChartComponent.schema()
};
exports.default = ChartComponent;
